const FADE_TIME = 400
const DURATION = 4000
function Snackbar({ $window, sync }) {
  let messages = []
  return {
    get messages() {
      messages = messages.filter(message => !message.isDismissed())
      if (messages.length > 0) {
        sync()
      }
      return messages
    },
    addMessage({ text, isError = false }) {
      const message = SnackbarMessage({
        $window,
        text,
        isError,
      })
      messages.unshift(message)
      sync()
    },
    __proto__: Snackbar.prototype,
  }
}

function SnackbarMessage({
  $window,
  text,
  isError,
}) {
  let createdAt = $window.Date.now()
  return {
    text() {
      return text
    },
    className() {
      return [
        'snackbar-message',
        isError ? 'error' : '',
      ].filter(Boolean).join(' ')
    },
    messageOpacity() {
      const elapsed = elapsedTime()
      if (elapsed < FADE_TIME) {
        return elapsed / FADE_TIME

      } else if (elapsed > (DURATION + FADE_TIME)) {
        const fadeOutTime = elapsed - (DURATION + FADE_TIME)
        return 1 - (fadeOutTime / FADE_TIME)

      } else {
        return 1
      }
    },
    timerTransform() {
      const elapsed = elapsedTime()
      const pct = 100 - clamp(0, 100, (elapsed - FADE_TIME) / DURATION * 100)
      return `scaleX(${pct}%)`
    },
    isDismissed() {
      return elapsedTime() > (DURATION + 2*FADE_TIME)
    },
    dismiss() {
      createdAt = 0
    },
  }

  function clamp(min, max, x) {
    return Math.max(min, Math.min(x, max))
  }

  function elapsedTime() {
    return $window.Date.now() - createdAt
  }
}

Object.assign(exports, { Snackbar })
